<template>
  <div class="mx-auto flex w-full max-w-md flex-row items-center text-center">
    <div class="relative mr-2 flex items-center justify-center p-4">
      <BaseIcon size="24" class="text-on-primary-container z-20">{{ icon }}</BaseIcon>
      <BaseShape
        shape="12-sided-cookie"
        class="text-primary-container absolute z-10 h-full w-full"
      />
    </div>
    <div class="flex flex-col items-start justify-center">
      <h3 class="text-title-medium">{{ title }}</h3>
      <p v-if="description" class="text-body-medium text-on-surface-variant">
        {{ description }}
      </p>
    </div>
    <slot />
  </div>
</template>
<script setup lang="ts">
  import BaseIcon from '../base/icon/BaseIcon.vue'
  import BaseShape from '../base/shapes/BaseShape.vue'

  interface Props {
    title: string
    description?: string
    icon: string
  }

  const { title, description, icon } = defineProps<Props>()
</script>
